import { Effect, Layer, Stream } from 'effect';
import { ConfigurationTemplatesService } from './service';
import { GetForSpace, GetById } from './gavelTemplatesService/requests';
import { makeGetByIdResolver, makeGetForSpaceResolver } from './gavelTemplatesService/resolvers';
import { AxiosHttpService, HttpService } from '../../../services/http';
import { GavelConfig } from '../../../services/gavelConfig';
const makeGavelConfigurationTemplatesService = Effect.gen(function* () {
    const httpService = yield* HttpService;
    const { gavelUrl } = yield* GavelConfig;
    const getForSpace = (tenant, spaceId) => Effect.request(new GetForSpace({ baseUrl: gavelUrl, space: spaceId, tenant }), makeGetForSpaceResolver(httpService)).pipe(Effect.map(result => Stream.fromIterable(result)), Stream.unwrap);
    const getById = (tenant, template) => Effect.request(new GetById({ baseUrl: gavelUrl, templateId: template, tenant }), makeGetByIdResolver(httpService));
    return { getForSpace, getById };
});
export const BaseGavelTemplatesService = Layer.effect(ConfigurationTemplatesService, makeGavelConfigurationTemplatesService);
export const DefaultGavelTemplatesService = BaseGavelTemplatesService.pipe(Layer.provide(AxiosHttpService));
